/**
 * Langues de l'app mobile du personnel (`users.app_locale`), chacune écrite dans
 * sa propre langue : on la reconnaît sans lire le français. Partagé par l'app
 * mobile et la page web de la gouvernante ; module feuille, sans import.
 */
export const LANGUES_MOBILES = ['fr', 'en', 'ka', 'es', 'pt', 'ro', 'uk', 'ru', 'ar'] as const;
export type LangueMobile = (typeof LANGUES_MOBILES)[number];

export const NOMS_LANGUES: Record<LangueMobile, string> = {
    fr: 'Français',
    en: 'English',
    ka: 'ქართული',
    es: 'Español',
    pt: 'Português',
    ro: 'Română',
    uk: 'Українська',
    ru: 'Русский',
    ar: 'العربية',
};
